import { getPictureLink } from '@utils/imageResizer';
import propTypes from 'prop-types';
import { useEffect, useState } from 'react';

const validImageCache = new Set();

const Image = ({ src = '', alt = 'Image', ...props }) => {
    const [finalSource, setFinalSource] = useState(src);

    useEffect(() => {
        if (!src) return;

        const urlResized = getPictureLink(src);

        if (validImageCache.has(urlResized)) {
            setFinalSource(urlResized);
            return;
        }

        const loadImage = async () => {
            try {
                const response = await fetch(urlResized, { method: 'HEAD' }); //Head request to only check if the image exists without downloading it
                if (response.ok) {
                    validImageCache.add(urlResized);
                    setFinalSource(urlResized);
                } else {
                    setFinalSource(src);
                }
            } catch (e) {
                setFinalSource(src);
            }
        };

        loadImage();
    }, [src]);

    return <img src={finalSource} alt={alt} {...props} />;
};

Image.propTypes = {
    src: propTypes.string,
    alt: propTypes.string,
};

export default Image;
